var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 14 16",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m.700195 1.6998c0-.49705.402945-.899995.900005-.899995h10.8c.4971 0 .9.402945.9.899995v2.7c0 .2387-.0948.46762-.2636.6364l-4.2364 4.2364v3.2272c0 .2387-.09483.4676-.26361.6364l-1.8 1.8c-.2574.2574-.6445.3344-.98081.1951s-.55558-.4675-.55558-.8315v-5.0272l-4.236401-4.2364c-.168783-.16878-.263604-.3977-.263604-.6364z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.93bd10ca577702382c614673a4a6cc8c.svg";
export { ForwardRef as ReactComponent };